import { Controller } from 'stimulus'

// The Sample Disposition card on a job's Samples tab. Record Disposition and
// each strip's Edit open their dialog by id (data-modal); the dialogs run
// sample-disposition-dialog themselves.
export default class extends Controller {
  open(event) {
    event.preventDefault()
    const modal = document.getElementById(event.currentTarget.dataset.modal)
    if (modal) modal.classList.remove('hidden')
  }
}
